import { useState } from 'react';
import clsx from 'clsx';
import { Button } from '@alf/uikit';
import { useOtherSettings } from '@namespace/cms';
import { useDeviceStore } from '@namespace/device';
import { useI18n } from '@namespace/i18n';
import { useFiltersCtxStore } from '../store';
import { BaseFilter } from './BaseFilter';
import { ShowFilterButton } from './ShowFilterButton';

import styles from './index.module.css';

export const DataFilter = ({
  filterConfig,
  onSet,
  onChangeFilterData,
  containerClassName,
  filterClassName,
  filterButtonClassName,
  applyBtnClassName,
  controlWrapperClassName,
  arrowConfig,
  dataRole
}) => {
  const { isDesktop, isMobile } = useDeviceStore();
  const { isNeedShowFilterCounts = true } = useOtherSettings();
  const [isShowFilter, setIsShowFilter] = useState(false);
  const isChanged = useFiltersCtxStore('isChanged');
  const changesCount = useFiltersCtxStore('changesCount');
  const { t } = useI18n();
  const filterDataRole = dataRole && `${dataRole}-filter`;
  const filterOnChangeHandler = (key, value) => {
    const newValue = !value.value ? { ...value } : { [key]: value.value };
    onChangeFilterData(newValue);
  };

  // the view of filter depends on this parameter,
  // if it is false then filter will open/close by button like on mob version,
  // otherwise all fields in filter will be in a row like on desktop
  const isInline = !(
    isMobile ||
    filterConfig.length > 5 ||
    (filterConfig.length > 2 && !isDesktop)
  );

  if (isShowFilter || isInline) {
    return (
      <div className={containerClassName}>
        {!isInline && (
          <ShowFilterButton
            label={t('personalOffice.filter.hideFilters')}
            onClick={() => setIsShowFilter(false)}
            className={filterButtonClassName}
          />
        )}
        <div
          className={clsx(
            isInline ? styles.filterInline : styles.filter,
            filterClassName
          )}
        >
          <BaseFilter
            {...{
              filterConfig,
              isInline,
              filterOnChangeHandler,
              arrowConfig,
              dataRole: filterDataRole,
              controlWrapperClassName
            }}
          />
          <div
            className={clsx([
              isInline && styles.filterGroupInline,
              controlWrapperClassName
            ])}
          >
            <Button
              dataRole={dataRole && `${dataRole}-btn-apply`}
              size="l"
              actionType="color1"
              intent="primary"
              className={clsx([styles.applyFiltersButton, applyBtnClassName])}
              onClick={() => {
                setIsShowFilter(false);
                return onSet();
              }}
              disabled={!isChanged}
            >
              {t('personalOffice.filter.applyFilters')}
            </Button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <ShowFilterButton
      label={
        changesCount && isNeedShowFilterCounts
          ? t('personalOffice.filter.showFiltersCount', [changesCount])
          : t('personalOffice.filter.showFilters')
      }
      changesCount={changesCount}
      isNeedShowFilterCounts={isNeedShowFilterCounts}
      onClick={() => setIsShowFilter(true)}
      className={filterButtonClassName}
    />
  );
};
